import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.seal.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import KNB from '@dp/knb';
import Store from 'drip/store';
import { isProd } from '@/utils/openApp';
var preUrl = isProd ? 'https://h5.dianping.com' : 'https://h5.51ping.com';
export default function runPreLoad() {
  var timePromise = Object.seal({
    resCb: null,
    timeId: null
  });
  function resetTimePromise() {
    timePromise.timeId && clearTimeout(timePromise.timeId);
    timePromise.resCb = null;
    timePromise.timeId = null;
  }
  function removeStateWithPreLoad() {
    removePreLoadPageIdInfo();
    removeSeatPageLoadDone();
  }

  // 销毁后台选座页后 必须从客户端移除静态资源加载完成的状态
  function removeSeatPageLoadDone() {
    return _removeSeatPageLoadDone.apply(this, arguments);
  } // 查看后台选座页静态资源是否加载完成，即后台选座页是否具备打开条件
  function _removeSeatPageLoadDone() {
    _removeSeatPageLoadDone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Store.remove('background_seat_page_load_done');
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _removeSeatPageLoadDone.apply(this, arguments);
  }
  function getBackgroundSeatPageLoadDone() {
    return _getBackgroundSeatPageLoadDone.apply(this, arguments);
  }
  function _getBackgroundSeatPageLoadDone() {
    _getBackgroundSeatPageLoadDone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var loadDoneObj;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Store.get('background_seat_page_load_done');
          case 2:
            loadDoneObj = _context3.sent;
            if (loadDoneObj) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", false);
          case 5:
            return _context3.abrupt("return", loadDoneObj.seatPageMounted);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _getBackgroundSeatPageLoadDone.apply(this, arguments);
  }
  function setPreLoadPageIdInfo(pageId, projectId) {
    if (!pageId) return;
    if (!projectId) return;
    Store.set('preLoadPageIdInfo', {
      pageId: pageId,
      projectId: projectId
    });
  }
  function removePreLoadPageIdInfo() {
    return _removePreLoadPageIdInfo.apply(this, arguments);
  } // 获取项目id绑定的预加载选座页id  ---  用于清除预加载/打开预加载页面/检测存活态
  function _removePreLoadPageIdInfo() {
    _removePreLoadPageIdInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return Store.remove('preLoadPageIdInfo');
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _removePreLoadPageIdInfo.apply(this, arguments);
  }
  function getPreLoadPageIdInfo() {
    return _getPreLoadPageIdInfo.apply(this, arguments);
  } // 清除预加载
  function _getPreLoadPageIdInfo() {
    _getPreLoadPageIdInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var idInfo;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return Store.get('preLoadPageIdInfo');
          case 2:
            idInfo = _context5.sent;
            return _context5.abrupt("return", idInfo);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _getPreLoadPageIdInfo.apply(this, arguments);
  }
  function clearPreLoad() {
    return _clearPreLoad.apply(this, arguments);
  } // 执行预加载
  function _clearPreLoad() {
    _clearPreLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            KNB.unsubscribe({
              action: 'custom_seat_page_load_done'
            });
            KNB.unsubscribe({
              action: 'custom_open_background_seat_page'
            });
            return _context7.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(res) {
                var idInfo;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return getPreLoadPageIdInfo();
                    case 2:
                      idInfo = _context6.sent;
                      if (idInfo) {
                        _context6.next = 6;
                        break;
                      }
                      res();
                      return _context6.abrupt("return");
                    case 6:
                      removeStateWithPreLoad();
                      KNB.use('movieshow.preloadWeb', {
                        preLoadPageID: idInfo.pageId,
                        action: 2,
                        success: function success() {
                          res();
                        },
                        fail: function fail() {
                          res();
                        }
                      });
                    case 8:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return function (_x5) {
                return _ref4.apply(this, arguments);
              };
            }()));
          case 3:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return _clearPreLoad.apply(this, arguments);
  }
  function preLoadWebPage(_ref, successCb, failCb) {
    var url = _ref.url,
      projectId = _ref.projectId;
    if (!projectId) return;
    if (!url) return;
    KNB.use('movieshow.preloadWeb', {
      url: preUrl + url,
      action: 0,
      success: function success(res) {
        successCb && successCb(res);
        subscribeSeatLoadDone();
        setPreLoadPageIdInfo(res.preLoadPageID, projectId);
        // 调用客户端预加载API成功后，订阅后台选座页静态资源加载完成事件
      },

      fail: function fail(error) {
        failCb && failCb(error);
      }
    });
  }

  // 将后台已预加载的页面推到前台，
  function openPreLoadPage(_x, _x2, _x3) {
    return _openPreLoadPage.apply(this, arguments);
  } // 检测预加载页面是否存活
  function _openPreLoadPage() {
    _openPreLoadPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(backupUrl, successCb, failCb) {
      var idInfo;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (backupUrl) {
              _context8.next = 2;
              break;
            }
            throw new Error('必须传backupUrl参数');
          case 2:
            _context8.next = 4;
            return getPreLoadPageIdInfo();
          case 4:
            idInfo = _context8.sent;
            if (idInfo) {
              _context8.next = 8;
              break;
            }
            failCb({
              message: '未获取到存储的预加载选座页ID'
            });
            return _context8.abrupt("return");
          case 8:
            KNB.use('movieshow.preloadWeb', {
              backupUrl: preUrl + backupUrl,
              preLoadPageID: idInfo.pageId,
              action: 1,
              success: function success(res) {
                successCb && successCb(res);
              },
              fail: function fail(error) {
                failCb && failCb(error);
              }
            });
          case 9:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return _openPreLoadPage.apply(this, arguments);
  }
  function checkBackgroundPageAlive() {
    return _checkBackgroundPageAlive.apply(this, arguments);
  }
  function _checkBackgroundPageAlive() {
    _checkBackgroundPageAlive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var idInfo;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return getPreLoadPageIdInfo();
          case 2:
            idInfo = _context9.sent;
            if (idInfo) {
              _context9.next = 5;
              break;
            }
            return _context9.abrupt("return", false);
          case 5:
            return _context9.abrupt("return", new Promise(function (resCb) {
              KNB.use('movieshow.preloadWeb', {
                preLoadPageID: idInfo.pageId,
                action: 3,
                success: function success(res) {
                  resCb(res.actionResult);
                },
                fail: function fail() {
                  resCb(false);
                }
              });
            }));
          case 6:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return _checkBackgroundPageAlive.apply(this, arguments);
  }
  function publishOpenBackgroundSeatPageEvent(data) {
    if (!data) {
      throw new Error('发布打开后台选座页事件必须发送数据 -- 项目id/modelStyle/sourceType/sId/sName');
    }
    KNB.publish({
      type: 'native',
      // 指定native后，无需设置bizname
      action: 'custom_open_background_seat_page',
      // 自定义的action名称，由webview传给native，业务方需根据业务需求增加相应的action处理
      data: data,
      // 与native的通信内容，由业务方自由定义data对象体的内容
      success: function success() {},
      fail: function fail() {}
    });
  }
  function subscribeSeatLoadDone() {
    KNB.subscribe({
      action: 'custom_seat_page_load_done',
      handle: function handle() {
        Store.set('background_seat_page_load_done', {
          seatPageMounted: true
        });
        if (timePromise.resCb && timePromise.timeId) {
          timePromise.resCb();
          resetTimePromise();
        }
      },
      success: function success() {},
      fail: function fail() {}
    });
  }
  function waitSetTimeoutDone() {
    return _waitSetTimeoutDone.apply(this, arguments);
  }
  function _waitSetTimeoutDone() {
    _waitSetTimeoutDone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var time,
        _args11 = arguments;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            time = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : 2000;
            if (timePromise.timeId) clearTimeout(timePromise.timeId);
            return _context11.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(res) {
                var seatLoadDone;
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) switch (_context10.prev = _context10.next) {
                    case 0:
                      _context10.next = 2;
                      return getBackgroundSeatPageLoadDone();
                    case 2:
                      seatLoadDone = _context10.sent;
                      if (!seatLoadDone) {
                        _context10.next = 6;
                        break;
                      }
                      res();
                      return _context10.abrupt("return");
                    case 6:
                      timePromise.resCb = res;
                      timePromise.timeId = setTimeout(function () {
                        res();
                        resetTimePromise();
                      }, time);
                    case 8:
                    case "end":
                      return _context10.stop();
                  }
                }, _callee10);
              }));
              return function (_x6) {
                return _ref5.apply(this, arguments);
              };
            }()));
          case 3:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return _waitSetTimeoutDone.apply(this, arguments);
  }
  var checkCanOpenPreLoadPage = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var setLoading, closeLoading, seatLoadDone, loadDone, seatPageAlive;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setLoading = _ref2.setLoading, closeLoading = _ref2.closeLoading;
            _context.next = 3;
            return getBackgroundSeatPageLoadDone();
          case 3:
            seatLoadDone = _context.sent;
            if (seatLoadDone) {
              _context.next = 14;
              break;
            }
            setLoading();

            // 设置定时器 -- 2秒内后台选座页加载完成继续第二层校验  超过2秒还未加载完成直接放弃
            _context.next = 8;
            return waitSetTimeoutDone();
          case 8:
            /*
              如果详情页在2秒内收到后台选座页发布的加载完成事件
              会取消定时器 设置promise为完成状态
              仍然会执行下面代码
            */
            closeLoading();
            _context.next = 11;
            return getBackgroundSeatPageLoadDone();
          case 11:
            loadDone = _context.sent;
            if (loadDone) {
              _context.next = 14;
              break;
            }
            return _context.abrupt("return", false);
          case 14:
            _context.next = 16;
            return checkBackgroundPageAlive();
          case 16:
            seatPageAlive = _context.sent;
            return _context.abrupt("return", seatPageAlive);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function checkCanOpenPreLoadPage(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  return {
    publishOpenBackgroundSeatPageEvent: publishOpenBackgroundSeatPageEvent,
    openPreLoadPage: openPreLoadPage,
    preLoadWebPage: preLoadWebPage,
    clearPreLoad: clearPreLoad,
    checkCanOpenPreLoadPage: checkCanOpenPreLoadPage
  };
}